import * as React from "react";
const TalkMicIcon = (props) => (
  <svg
    width={148}
    height={148}
    viewBox="0 0 148 148"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={74.0002}
      cy={74.0012}
      r={73.2121}
      fill="url(#paint0_linear_1_4)"
    />
    <path
      d="M74.0005 52.2597C69.9992 52.2597 66.7555 55.5033 66.7555 59.5046V71.5795C66.7555 75.5808 69.9992 78.8245 74.0005 78.8245C78.0017 78.8245 81.2454 75.5808 81.2454 71.5795V59.5046C81.2454 55.5033 78.0017 52.2597 74.0005 52.2597ZM76.4155 93.1817V96.9368C76.4155 98.2706 75.3342 99.3518 74.0005 99.3518C72.6667 99.3518 71.5855 98.2706 71.5855 96.9368V93.1817C60.7182 91.9804 52.2656 82.7671 52.2656 71.5795C52.2656 70.2458 53.3468 69.1645 54.6806 69.1645C56.0144 69.1645 57.0956 70.2458 57.0956 71.5795C57.0956 80.9158 64.6642 88.4844 74.0005 88.4844C83.3368 88.4844 90.9054 80.9158 90.9054 71.5795C90.9054 70.2458 91.9866 69.1645 93.3203 69.1645C94.6541 69.1645 95.7353 70.2458 95.7353 71.5795C95.7353 82.7671 87.2828 91.9804 76.4155 93.1817ZM74.0005 47.4297C80.6693 47.4297 86.0754 52.8358 86.0754 59.5046V71.5795C86.0754 78.2483 80.6693 83.6544 74.0005 83.6544C67.3317 83.6544 61.9256 78.2483 61.9256 71.5795V59.5046C61.9256 52.8358 67.3317 47.4297 74.0005 47.4297Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1_4"
        x1={-17.8226}
        y1={286.419}
        x2={308.036}
        y2={269.341}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8b58f1" />
        <stop offset={1} stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
export default TalkMicIcon;
